import { useEffect } from 'react';
import Box from '@mui/material/Box';
import { useNavigate, useParams } from 'react-router-dom';
import { useProfileData } from '../../hooks/useProfileData';
import { useAuth } from '../../hooks/useAuth';
import UserProfileData from './userProfileData';
import { usePreloadedIndex } from '../../hooks/usePreloadedIndex';
import LoadingPage from '../LoadingPage';

export default function CreatorProfile() {
  const { userName: userNameParam } = useParams();
  const userName = userNameParam?.toLowerCase();

  const [ , ] = usePreloadedIndex();
  const navigate = useNavigate();
  const { authUser } = useAuth();
  const { fetchProfileDataFromUserName, creatorProfileData, isLoadingProfile } =
    useProfileData();

  useEffect(() => {
    if (userName && creatorProfileData?.userName.toLowerCase() !== userName) {
      checkValidUserAndFetchProfileData();
    }
  }, [userName, creatorProfileData]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // if authUser is updated, also update creatorProfileData
    if (authUser?.userName === creatorProfileData?.userName.toLowerCase()) {
      checkValidUserAndFetchProfileData();
    }
  }, [authUser])

  const checkValidUserAndFetchProfileData = async () => {
    fetchProfileDataFromUserName(
      userName,
      authUser?.uid,
      authUser?.userName?.toLowerCase() === userName,
      () => {
        navigate('/creators')
      }
    )
  };

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      {(
        (userName &&
        creatorProfileData?.userName.toLowerCase() !== userName.toLowerCase()) ||
        (!creatorProfileData?.index && isLoadingProfile)
      ) ? (
        <LoadingPage />
      ) : (
        <UserProfileData />
      )}
    </Box>
  );
}
